
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';
import { IdDescricao } from '@app/models/util/id-descricao';
import { Filtros } from './filtros';
import { ToastrService } from 'ngx-toastr';

import debounce from '@app/utils/debounce';

import { RelatorioService } from '@app/services/relatorio.service';
import { ConsultasService } from '@app/services/consultas.service';
import { UtilitarioService } from '@app/services/utilitario.service';


@Component({
  selector: 'app-relcheques',
  templateUrl: 'cheques.component.html',
  styleUrls: ['./cheques.component.scss']
})
export class RelatorioChequeComponent implements OnInit {


  cdsMask: CDSMask = new CDSMask();
  filtros: Filtros = new Filtros();

  lstParticipante: Array<any> = [{}];
  lstUnidades: IdDescricao[];
  lstConta: IdDescricao[] = [];

  rel: any[];

  totalPagar = 0;
  totalLiberadoPagar = 0;
  pesquisando: boolean;
  showTable: boolean = false;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }


  ngOnInit() {
    this.filtros.ProcessoId = null;
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
    this.consultasService.consultar('CONTA').toPromise().then(data => this.lstConta = data);
  }
  pesquisar() {
    this.rel = [];
    this.pesquisando = true;
    this.relatorioService.cheques(this.filtros).toPromise().then((data) => {
      this.rel = data;
      this.somaSaldo();
      this.pesquisando = false;

      if (this.rel.length === 0) {
        this.showTable = false;
        this.toastr.info("Busca não encontrou resultados");
      } else {
        this.showTable = true;
      }
    }, erro => {
      this.pesquisando = false
      this.toastr.warning("Realize a pesquisa novamente.")
    });
    //  () => this.pesquisando = false);
  }

  public somaSaldo(): void {
    this.totalPagar = 0; this.totalLiberadoPagar = 0;
    this.rel.forEach(element => { this.totalPagar += element.Valor; });
    this.rel.filter(x => x.Liberada == 'SIM').forEach(element => { this.totalLiberadoPagar += element.Valor; });
  }

  _debounce: any;
  _pesquisa: any;
  public ngxselect_typed(value: any): void {

    this.lstParticipante = [{ id: -1, text: 'Pesquisando...' + value, disabled: true }];
    this._pesquisa = value;
    if (!this._debounce) {
      this._debounce = debounce(() => {
        this.consultasService.consultar('PARTICIPANTE', this._pesquisa).toPromise().then(data => {
          this.lstParticipante = data;
        });
      }, 500);
    }
    this._debounce();
  }

  @ViewChild('relatorio') relatorio: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("cheques").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório Cheques", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();
    
    adicionaMapValido("Titular", this.filtros.Titular);
    adicionaMapValido("Número", this.filtros.Numero);
    
    parseDateAdicionaMap('Vencimento Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap('Vencimento Final', this.filtros.DataFinal);    

    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);
    obtemDescricaoAdicionaMap('Conta', this.lstConta, this.filtros.ContaId);
    
    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

}
